import { useEffect } from 'react';
import { getAppName } from 'utils/getAppName';
import { isSaaS } from 'utils/isSaaS';
import { getStandFromEnv } from 'utils/stand';
import { getPwaIcons } from '../../constants/iconConfigs';

/**
 * Компонент для динамического обновления manifest.json
 * Обновляет название приложения и иконки в зависимости от типа окружения
 */
export const DynamicManifest: React.FC = () => {
  useEffect(() => {
    const updateManifest = async () => {
      const appName = getAppName();
      const stand = getStandFromEnv();
      const isSaaSApp = isSaaS();

      // Получаем иконки для PWA
      const icons = getPwaIcons(stand, isSaaSApp);

      // Обновляем manifest.json
      const manifest = {
        short_name: appName,
        name: isSaaSApp ? appName : `Самолет ${appName}`,
        start_url: '.',
        display: 'standalone',
        theme_color: '#000000',
        background_color: '#ffffff',
        icons: icons.map(icon => ({
          src: icon.href,
          sizes: icon.sizes || 'any',
          type: icon.type,
        })),
      };

      // Создаем новый link элемент для manifest
      const link = document.createElement('link');
      link.rel = 'manifest';

      // Используем encodeURIComponent для безопасного кодирования Unicode символов
      const jsonString = JSON.stringify(manifest);
      const encodedJson = encodeURIComponent(jsonString);
      link.href = `data:application/json;charset=utf-8,${encodedJson}`;

      // Удаляем старый manifest если есть
      const oldLink = document.querySelector('link[rel="manifest"]');
      if (oldLink) {
        oldLink.remove();
      }

      // Добавляем новый manifest
      document.head.appendChild(link);
    };

    updateManifest();
  }, []);

  return null;
};
